import { Component, OnInit, Inject } from '@angular/core';
import {
  MsalBroadcastService,
  MsalService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { InteractionStatus, EventType, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { LocationService } from '../services/location.service';

@Component({
  selector: 'app-login-redirect',
  templateUrl: './login-redirect.component.html',
  styleUrls: ['./login-redirect.component.css'],
})
export class LoginRedirectComponent implements OnInit {
  loginDisplay = false;
  private locationTracked = false;

  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private locationService: LocationService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) { }

  ngOnInit(): void {
    // Listen for login success events
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe((result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);
        
        // Only track location if not already tracked in this session
        if (!this.locationTracked) {
          this.locationTracked = true;
          this.trackUserLocation(payload);
        }
      });

    // Handle login status changes
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  /**
   * Track user location on successful login
   * Uses the LocationService to detect and record user's geographic location
   */
  private trackUserLocation(authResult: AuthenticationResult): void {
    // Get token claims from the authentication result
    const account = authResult.account;
    const tokenClaims = account?.idTokenClaims || {};
    
    // Use location service to track user location
    this.locationService.trackUserLocation(tokenClaims).subscribe(
      response => {
        // Location tracking successful
        // console.log('Location tracking successful');
      },
      error => {
        // Location tracking failed but we don't want to block the user
        // console.log('Location tracking failed:', error);
      }
    );
  }
}
